module.exports = __webpack_public_path__ + "img/word.dc300f78.png";